import { combineReducers } from '@reduxjs/toolkit'
import { commonReducerMap } from '@labrav/common'
import { marketplaceReducerMap } from '@labrav/marketplace'

import { appReducerMap } from './reducer'

export const rootReducer = combineReducers({
  ...commonReducerMap,
  ...marketplaceReducerMap,
  ...appReducerMap,
})

export type RootReducerState = ReturnType<typeof rootReducer>
